import { APIGetRequest } from "@/utils/requests";
import { type Product } from "@punchup/data";
import { ProductCategory } from "@/data/v2/models/products";
import { getApiClient } from "@punchup/utils/apiRegistry";

export type GetProductsParams = {
  collectionId?: string;
  comedianId?: string;
  productId?: string;
  category?: ProductCategory;
};

export async function getProducts(
  params: GetProductsParams
): Promise<Product[]> {
  const searchParams = new URLSearchParams();

  if (params.collectionId) {
    searchParams.append("collection_id", params.collectionId);
  }
  if (params.comedianId) {
    searchParams.append("comedian_id", params.comedianId);
  }
  if (params.productId) {
    searchParams.append("product_id", params.productId);
  }
  if (params.category) {
    searchParams.append("category", params.category);
  }

  const apiClient = getApiClient();
  const response = await apiClient.get<{
    data: Product[];
  }>(`/api/v2/public/products?${searchParams.toString()}`);
  return response.data;
}

export async function getAllProductsForSpecial(
  specialId: string
): Promise<Product[]> {
  const apiClient = getApiClient();
  const response = await apiClient.get<{
    data: Product[];
  }>(`/api/v2/public/specials/${specialId}/products`);
  return response.data;
}

export async function getAllProductsForSpecials(
  specialIds: string[]
): Promise<Record<string, Product[]>> {
  const apiClient = getApiClient();
  const response = await apiClient.get<{
    data: Record<string, Product[]>;
  }>(`/api/v2/public/specials/products?ids=${specialIds.join(",")}`);
  return response.data;
}
